import { render, staticRenderFns } from "./FontControls.vue?vue&type=template&id=df67a43a&scoped=true&"
import script from "./FontControls.vue?vue&type=script&lang=js&"
export * from "./FontControls.vue?vue&type=script&lang=js&"
import style0 from "./FontControls.vue?vue&type=style&index=0&id=df67a43a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df67a43a",
  null
  
)

export default component.exports